import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { LogService } from '../../../services/log.service';
import { TranslationService } from '../../../services/translation.service';
import { ConfigService } from '../../../services/config.service';
import { NavBarService } from '../../../services/nav-bar.service';
import { IconBarService } from '../../../services/icon-bar.service';
import { DataIoService } from '../../../services/data-io.service';
import { ValueChangedConfirmation } from '../../../classes/ValueChangedConfirmation';
import { Helper, MenuNode, BaseSensor, ISensorInterface } from '../../../classes';

@Component({
  selector: 'app-timeset',
  templateUrl: './timeset.component.html',
  styleUrls: ['./timeset.component.scss']
})
export class TimesetComponent implements OnInit {
	steps=['inactive','hour','minute','day','month','year'];
	step:string='inactive';
	time :Date = new Date();
	_active : boolean = false;
	_cursor:boolean = false;
	b():string{
		switch(this.step){
			case 'inactive':{
				return Helper.twoDigits( this.time.getHours() )+':'+Helper.twoDigits( this.time.getMinutes() );
			}
			case 'hour':{
				if(!this._cursor){
					return '  :'+Helper.twoDigits( this.time.getMinutes() );	
				}
				return Helper.twoDigits( this.time.getHours() )+':'+Helper.twoDigits( this.time.getMinutes() );
			}
			case 'minute':{
				if(!this._cursor){
					return Helper.twoDigits( this.time.getHours() )+':  ';
				}
				return Helper.twoDigits( this.time.getHours() )+':'+Helper.twoDigits( this.time.getMinutes() );
			}
			case 'month':
			case 'day':{
				return (""+ this.time.getFullYear() );
			}
			case 'year':{
				if(!this._cursor){
					return '    ';
				}else{
					return (""+ this.time.getFullYear() );
				}
			}
			default:{
				return '';
			}
		}

	}
	s():string{
		switch(this.step){
			case 'hour':
			case 'minute':
			case 'inactive':{
				return '';
			}
			case 'day':{
				if(!this._cursor){
					return '  .'+Helper.twoDigits( (this.time.getMonth()+1) );					
				}
				return Helper.twoDigits( this.time.getDate() )+'.'+Helper.twoDigits( (this.time.getMonth()+1) );
			}
			case 'month':{
				if(!this._cursor){
					return Helper.twoDigits( this.time.getDate() )+'. ';
				}
				return Helper.twoDigits( this.time.getDate() )+'.'+Helper.twoDigits( (this.time.getMonth()+1) );
			}
			case 'year':{
				return Helper.twoDigits( this.time.getDate() )+'.'+Helper.twoDigits( (this.time.getMonth()+1) );
			}
			default:{
				return '';
			}
		}

	}
	constructor(
        private menuService: MenuService, 
        private ioService: DataIoService, 
        private logger: LogService, 
        private config: ConfigService, 
        private translator:TranslationService,
        private navBar: NavBarService,
        private iconBar: IconBarService
        ){

	}
	blinkButton(){
	        this.menuService.blinkButton('confirm');
    }

	backClicked(){
		if(this.step == 'inactive'){
			this.menuService.goto('dashboard');
		}
 		let idx = this.steps.length+this.steps.indexOf(this.step)-1;
		this.step = this.steps[idx%this.steps.length];
	}
	upClicked(){
		this.increase();
	}
	
	downClicked(){
		this.decrease();
	}
    increase(val?:number){
  		if(!val){
  			val=1;
  		}
      let day = this.time.getDate();
      let month = this.time.getMonth();
      let year = this.time.getFullYear();
      let hours = this.time.getHours();
      let minutes = this.time.getMinutes();
      let seconds = this.time.getSeconds();
      let cyclic = false; // is 23 hours + 1 hour = 0 hours possible?
      // tage der monate
      let moduls = [31, (year % 4 == 0)?29:28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  		switch(this.step){
  			case 'minute':{
          if(!cyclic){
            if(val >0 && minutes == 59){
              return;
            }
            if(val < 0 && minutes == 0){
              return;
            }
          }
          this.time.setMinutes( (this.time.getMinutes()+val) % 60 );
  				return;
  			}
  			case 'hour':{
          let newHours = (this.time.getHours()+val) % 24;
          if(!cyclic){
            if(val > 0 && hours == 23){
              newHours = 23;
            }
            if(val < 0 && hours == 0){
              newHours = 0;
            }
          }
          this.time.setHours(newHours);
  				return;
  			}
  			case 'day':{
          let newDay = day+val;
          if(cyclic){
            if(newDay < 1){
              newDay = moduls[month];
            }
            if(newDay > moduls[month]){
              newDay = 1;
            }
          }else{
            if(newDay < 1){
              newDay = 1;
            }
            if(newDay > moduls[month]){
              newDay = moduls[month];
            }
          }

          this.time = new Date(year,month,newDay,hours,minutes,seconds);
          
          return;
  			}
  			case 'month':{
          let newMonth = ( (month+val)%(12) );
          if(!cyclic){
            if(month == 11 && val > 0){
              newMonth = 11;
            }
            if(month == 0 && val < 0){
              newMonth = 0;
            }
          }
          let newDay = day;

          while(newDay > moduls[newMonth]){

            newDay--;
          }
          this.time = new Date(year,newMonth,newDay,hours,minutes,seconds);

  				return;
  			}
  			case 'year':{
          if(this.time.getFullYear() == 2099 && val > 0){
            if(cyclic){
              this.time.setFullYear(2001);
            }
            return;
          }
          if(this.time.getFullYear() == 2001 && val < 0){
            if(cyclic){
              this.time.setFullYear(2099);
            }
            return;
          }
          
  				this.time.setFullYear(this.time.getFullYear()+val);
  				return;
  			}
  			default:{
  			}
  		}
  	}
  	decrease(val?:number){
  		if(!val){
  			val=1;
  		}
  		this.increase(-1*val);
  	}
	
	confirmClicked(){
		this.menuService.buttonEnabled('up');
		this.menuService.buttonEnabled('down');
 		let idx = this.steps.indexOf(this.step)+1;
		this.step = this.steps[idx%this.steps.length];
		if(this.step == 'inactive'){
			this.ioService.setTime(this.time);
		}
	}
	changed(){
		this.menuService.undisableButton('up');
		this.menuService.undisableButton('down');

	}
	eventHandler(e:string){
		switch(e){
			case 'up':{
				this.upClicked();
				return;
			}
			case 'down':{
				this.downClicked();
				return;
			}
			case 'confirm':{
				this.changed();
				this.confirmClicked();
				return;
			}
			case 'menu':{
				this.menuService.goto('waterpressure_widget');
				return;
			}
			case 'back':{
				this.backClicked();
				return;
			}
			default:{

			}

		}
	}
	sub:any=undefined;
	interval:any=undefined;
	ngOnInit(){
		this.menuService.disableButton('up');
		this.menuService.disableButton('down');
		if(this.ioService.getConfiguration().simulatorConfig.hasControl()){
			this.menuService.disableButton('confirm');
		}
		this.time = new Date(this.ioService.getCurrentTime());		
		this.sub = this.ioService.inputs.events$.subscribe( (e) => { this.eventHandler(e); } ) ;
		this.interval = setInterval( ()=>{
			this._cursor = !this._cursor;
		},600);
		this.navBar.enableAll();
		this.navBar.blink('adjusttime');

	}
	ngOnDestroy(){
		if(this.interval){
			clearInterval(this.interval);
		}
		if(this.sub){
			this.sub.unsubscribe();
		}
	}
}
